<template>
  <el-container class="app-shell">
    <el-aside width="220px" class="sidebar">
      <div class="logo"><span class="brand-mark">S</span><div>用户中心<small>店铺与权限管理</small></div></div>
      <el-menu :default-active="$route.path" router background-color="#172a3a" text-color="#b9c9d4" active-text-color="#70dbc9">
        <el-menu-item v-for="item in visibleMenu" :key="item.path" :index="item.path"><i :class="item.icon"></i><span>{{ item.label }}</span></el-menu-item>
      </el-menu>
      <div class="sidebar-bottom"><span v-if="isDemo" class="demo-badge">演示模式 · 只读</span><el-button type="text" class="logout" icon="el-icon-switch-button" @click="logout">退出登录</el-button></div>
    </el-aside>
    <el-container class="workspace-container">
      <el-header class="topbar"><div><span class="crumb">用户中心</span><span class="divider">/</span><span>{{ pageTitle }}</span></div><div class="actor"><span>{{ actorName }}</span><el-button type="text" icon="el-icon-setting" @click="$router.push('/profile')">个人设置</el-button></div></el-header>
      <el-main><el-alert v-if="isDemo" title="当前为演示模式，数据为只读示例，保存操作已禁用" type="info" :closable="false" show-icon class="demo-alert" /><router-view /></el-main>
    </el-container>
  </el-container>
</template>

<script>
import { filterMenuByPermissions } from '../router/permissions.cjs';
const menu = [
  { path: '/dashboard', label: '概览看板', permission: 'dashboard.view', icon: 'el-icon-data-analysis' },
  { path: '/stores', label: '团队管理', permission: 'stores.view', icon: 'el-icon-s-shop' },
  { path: '/users', label: '账号管理', permission: 'users.view', icon: 'el-icon-user' },
  { path: '/roles', label: '角色与权限', permission: 'roles.view', icon: 'el-icon-lock' },
  { path: '/ai-settings', label: '豆包 AI 设置', permission: 'ai.settings.view', icon: 'el-icon-monitor' }
];
export default {
  name: 'AppLayout',
  computed: {
    actorName() { const actor = this.$store.state.actor || {}; return actor.display_name || actor.username || '访客'; },
    isDemo() { return this.$store.getters.isDemo; },
    pageTitle() { return (this.visibleMenu.find((item) => item.path === this.$route.path) || {}).label || '个人设置'; },
    visibleMenu() { return filterMenuByPermissions(menu, this.$store.getters.permissions); }
  },
  methods: {
    async logout() {
      try { await this.$store.dispatch('logout'); }
      catch (_) { /* Session is always cleared locally by the store. */ }
      if (this.$route.path !== '/login') this.$router.replace('/login');
    }
  }
};
</script>

